import { render, staticRenderFns } from "./settingTable.vue?vue&type=template&id=1c07e104&"
import script from "./settingTable.vue?vue&type=script&lang=ts&"
export * from "./settingTable.vue?vue&type=script&lang=ts&"
import style0 from "./settingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports